import {
  ACCOUNT_DELETION_REASONS,
  ACCOUNT_DELETION_REASON_LABEL,
} from "@/types/account-deletion-survey";
import type { AccountDeletionReasonCount } from "@/types/account-deletion-survey";

interface Props {
  reasonCounts: AccountDeletionReasonCount[];
}

export function AccountDeletionReasonSummary({ reasonCounts }: Props) {
  const countByReason = new Map(
    reasonCounts.map((item) => [item.reason, item.count]),
  );
  const total = reasonCounts.reduce((sum, item) => sum + item.count, 0);

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      <div className="rounded-xl border bg-card p-4 shadow-sm">
        <p className="text-xs text-muted-foreground">전체</p>
        <p className="mt-1 text-2xl font-semibold tabular-nums">
          {total.toLocaleString()}
        </p>
      </div>
      {ACCOUNT_DELETION_REASONS.map((reason) => (
        <div key={reason} className="rounded-xl border bg-card p-4 shadow-sm">
          <p className="text-xs text-muted-foreground">
            {ACCOUNT_DELETION_REASON_LABEL[reason]}
          </p>
          <p className="mt-1 text-2xl font-semibold tabular-nums">
            {(countByReason.get(reason) ?? 0).toLocaleString()}
          </p>
        </div>
      ))}
    </div>
  );
}
